import { ValidationError } from "sequelize"
import {
    MarkovState,
    MarkovStateCreate,
    MarkovStateSave,
} from "server/models"
import { OrderType } from "client/utils"
import {
    GET, POST, DELETE, sort, search, validate,
} from "client/store/utils"
import { LangType } from "client/store"
import {
    MarkovStateList,
    MarkovStateFilters,
    MarkovStateValidation,
} from "./types"


export const LoadAllMarkovStates = (modelId: number) => (
    GET(`/markovState/modelId/${modelId}`)
    .then((states: MarkovState[]) => {
        const stateList: MarkovStateList = {}
        states.forEach((state) => {
            stateList[state.id] = state
        })
        return stateList
    })
)

export const LoadMarkovStateById = (stateId: number, modelId: number) => (
    GET(`/markovState/id/${stateId}/modelId/${modelId}`)
    .then((state: MarkovState) => state)
)

export const SaveMarkovState = (
    id: number,
    state: MarkovStateCreate,
    lang: LangType,
) => {
    const data: MarkovStateSave = {
        id,
        state,
    }
    return POST(
        "/markovState/save",
        JSON.stringify(data),
    ).then((res) => {
        const newState = res as MarkovState
        const error = res as ValidationError

        return {
            newStateId: newState.id || null,
            validation: <MarkovStateValidation>validate(error, lang),
        }
    })
}

export const DeleteMarkovState = (stateId: number, modelId: number) => (
    DELETE(`/markovState/delete/${stateId}/${modelId}`)
    .then((removedRows: number) => removedRows)
)

export const SortMarkovStates = (
    states: MarkovState[],
    sortColumn: keyof MarkovState,
    sortOrder: OrderType,
    filters: MarkovStateFilters,
) => {
    const statesFiltered = states.filter((state) => {
        let showRow = true
        if (filters.search) showRow = search(filters.search, state)
        return showRow
    })
    statesFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const stateIds: number[] = []
    statesFiltered.forEach((state) => stateIds.push(state.id))

    return stateIds
}
